import React from 'react';
import Banner from '../components/home/Banner';
import Services from '../components/home/Services';
import AboutSection from '../components/home/AboutSection';
import Testimonials from '../components/home/Testimonials';

const Home = () => {
  return (
    <div>
      <Banner />
      <Services />
      <AboutSection />
      <Testimonials />
    </div>
  );
};

export default Home; 